import React, { createContext, useEffect, useState } from 'react'
import { getAllProductContexts, getAllProducts } from 'src/supportPortal/services/docSideService'

export const DocsideCmsContext = createContext()

export default function DocsideCmsContextProvider({ children }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [products, setProducts] = useState([])

  const [contexts, setContexts] = useState([])
  const [loadingContexts, setLoadingContexts] = useState(false)
  const [errorContexts, setErrorContexts] = useState(null)

  // Load products on component mount
  useEffect(() => {
    loadProducts()
    loadContexts()
  }, [])

  const loadContexts = async () => {
    setLoadingContexts(true)
    setErrorContexts(null)
    try {
      const response = await getAllProductContexts()
      if (response?.status === 200) {
        setContexts(response.data || [])
      } else {
        setErrorContexts('Failed to load contexts')
      }
    } catch (err) {
      setErrorContexts('Failed to load contexts: ' + err.message)
    } finally {
      setLoadingContexts(false)
    }
  }

  const loadProducts = async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await getAllProducts()
      if (response?.status === 200) {
        setProducts(response.data || [])
      } else {
        setError('Failed to load products')
      }
    } catch (err) {
      setError('Failed to load products: ' + err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <DocsideCmsContext.Provider
      value={{
        products,
        loadingProducts: loading,
        errorProducts: error,
        loadProducts,
        contexts,
        loadingContexts,
        errorContexts,
        loadContexts,
      }}
    >
      {children}
    </DocsideCmsContext.Provider>
  )
}
